package com.anjuros.website.templates.template6.util

import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.components.shared.DetailsType
import com.anjuros.website.templates.template6.util.Template6Constants.CLIENTS_COMPANY
import com.anjuros.website.templates.template6.util.Template6Constants.CLIENTS_COMPANY_NUMBER
import com.anjuros.website.templates.template6.util.Template6Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template6.util.Template6Constants.CLIENTS_OPENING_HOURS
import com.anjuros.website.templates.template6.util.Template6Constants.CLIENTS_PHONE
import com.anjuros.website.templates.template6.util.Template6Constants.CLIENTS_COMPANY_SERVICE_AREA

enum class Template6CompanyDetails: CompanyDetailsType {
    CLIENTS_EMAIL_INFO {
        override fun value(): String {
            return CLIENTS_EMAIL
        }

        override fun getType(): DetailsType {
            return DetailsType.EMAIL
        }
    },
    CLIENTS_COMPANY_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY
        }
    },
    CLIENTS_NAME_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY
        }
    },
    CLIENTS_COMPANY_NUMBER_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY_NUMBER
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_NUMBER
        }
    },
    CLIENTS_COMPANY_SERVICE_AREA_INFO {
        override fun value(): String {
            return CLIENTS_COMPANY_SERVICE_AREA
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_SERVICE_AREA
        }
    },
    CLIENTS_COMPANY_OPENING_HOURS {
        override fun value(): String {
            return CLIENTS_OPENING_HOURS
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_OPENING_HOURS
        }
    },
    CLIENTS_PHONE_INFO {
        override fun value(): String {
            return CLIENTS_PHONE
        }

        override fun getType(): DetailsType {
            return DetailsType.COMPANY_PHONE
        }
    },
}